import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { NO_TTY_JSON_OUTPUT_OPTION } from '@wix/cli-command-contract';
import { createCommand, Option } from '@commander-js/extra-typings';
import { validateBase, validateLabel } from './validations.js';

export const previewCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  return createCommand('preview')
    .option(
      '--base-url <url>',
      'The base url for when static files have been uploaded to an external cdn',
      validateBase
    )
    .option(
      '-l, --label <label>',
      'A custom label for this preview',
      validateLabel
    )
    .addOption(
      new Option(NO_TTY_JSON_OUTPUT_OPTION, 'Output in JSON format').hideHelp()
    )
    .action(async (options, command) => {
      const { baseUrl, json, label } = options;

      const { renderCommand, runCommand } = await import('./render-command.js');

      if (json) {
        return runCommand(command, services, cliVersion, async (model) => {
          const { nonInteractivePreview } = await import(
            '../non-interactive/preview.js'
          );
          return nonInteractivePreview(services, model, { baseUrl, label });
        });
      }

      const { PreviewCommand } = await import(
        '../components/PreviewCommand/index.js'
      );

      await renderCommand(
        command,
        services,
        cliVersion,
        <PreviewCommand baseUrl={baseUrl} label={label} environment="preview" />
      );
    });
};
